// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2gc2H","icon":"SortAdornment_icon__3ZVRk","up":"SortAdornment_up__3D_JI","down":"SortAdornment_down__35DBq","active":"SortAdornment_active__1Uf5l"};